import { createRESTStore } from "@stores/shared/createRESTStore";
import API from "@config/shared/api-paths";
import apiClient from "@services/api/apiClient";

const useAppStore = createRESTStore({
  entityName: "apps",
  apiPaths: {
    fetch: API.BASE + API.FRONTEND.APPS,
    get: API.BASE + API.FRONTEND.APPS,
  },
  processResponse: {
    fetch: (data) => data.items,
    get: (data) => data,
  },
  initialState: [],

  additionalActions: (set, get) => ({
    appData: null,
    fetchingItem: false,

    getAppData: async (id) => {
      set({ fetchingItem: true });
      try {
        const result = await apiClient.get(get().apiPaths.get + "/" + id);
        const itemData = result.data || result;
        set({ appData: itemData, fetchingItem: false });
        return itemData;
      } catch (error) {
        set({ fetchingItem: false });
        console.log(error);
      }
    },
  }),
});

export default useAppStore;
